import { AUTH_API_BASE_URL, urlFor, request } from '../index'

export async function getGameConfig() {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/coinsflip/game-config`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function updateGameConfig(data) {
  try {
    return request('patch', urlFor(AUTH_API_BASE_URL, `/coinsflip/game-config`), {
      auth: true,
      data: data,
    })
  } catch (e) {
    return e
  }
}

export async function getUserReport(text) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/coinsflip/user-report?${text}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}

export async function getUserDetailReport(text) {
  try {
    return request('get', urlFor(AUTH_API_BASE_URL, `/coinsflip/user-detail-report?${text}`), {
      auth: true,
    })
  } catch (e) {
    return e
  }
}
